<template>
  <div>
    Nous
  </div>
</template>

<script>
// @ is an alias to /src

export default {
  name: 'Nous'
}
</script>
